<template>
  <div>
    <template v-for="(item, index) in sortedPageLayout" :key="index">
      <DynamicBlock
        v-if="item.type === 'block' && item.block"
        :block="item.block"
      />
    </template>
  </div>
</template>

<script>
import Layout from '@/Layouts/Main.vue';
import DynamicBlock from '@/Shared/DynamicBlock.vue';

export default {
  components: { DynamicBlock },
  layout: Layout,
  props: {
    pageLayout: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sortedPageLayout() {
      return [...this.pageLayout].sort((a, b) => (a.order || 0) - (b.order || 0));
    },
  },
};
</script>
